import { useLoaderData } from "react-router";
import { loadRetreats } from "@/lib/retreats";
import RetreatCardDesignLabPage, {
  type RetreatCard,
} from "@/components/pages/RetreatCardDesignLabPage";

export async function retreatCardDesignLabLoader() {
  try {
    return await loadRetreats();
  } catch {
    return { retreats: [] as RetreatCard[] };
  }
}

export function RetreatCardDesignLab() {
  const { retreats } = useLoaderData() as { retreats: RetreatCard[] };

  return <RetreatCardDesignLabPage retreats={retreats} />;
}
